<template>
     <v-dialog
        v-model="dialog"
        max-width="1020px"
        persistent
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                @click="initialize"
                small
                class="mr-3"
            >Upload Students</v-btn>            
        </template>

        <v-expand-transition>
            <v-card
                v-show="expandFileSelect"
            >
                <v-card-title>
                    Upload Students
                    <v-btn
                        icon
                        class="ml-auto"
                        @click="close"
                    >
                        <v-icon color="red">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col class="px-0">
                                <v-file-input
                                    v-model="file"
                                    show-size
                                    label="Click to select file to upload."
                                    @change="selectFile"
                                    outlined
                                    dense
                                ></v-file-input>
                            </v-col>    
                        </v-row>
                        <v-row v-if="file">
                            <v-progress-linear
                                v-model="progress"
                                color="primary"
                                height="25"
                                reactive
                            >
                                <strong>{{ progress }} %</strong>
                            </v-progress-linear>
                        </v-row>

                        <v-alert v-if="message" border="left" :color="messageColor" dark>
                            {{ message }}
                        </v-alert>

                    </v-container>
                </v-card-text>
                <v-card-actions class="px-6">
                    <v-spacer></v-spacer>
                    <v-btn
                        outlined
                        class="mr-2"
                        color="primary"
                        @click="close"
                    >
                        Close Upload
                    </v-btn>
                    <v-btn
                        class="mr-2"
                        color="primary"
                        @click="downloadTemplate"
                    >
                        Download Template
                    </v-btn>
                    <!-- <v-btn
                        v-if="file"
                        color="primary"
                        dark
                        @click="uploadFile"
                    >Upload File</v-btn> -->
                </v-card-actions>
                <v-overlay
                    :value="overlayDownload"
                    :absolute="absolute"
                    color="#fff"
                    opacity="0.9"
                >
                    <v-progress-circular                        
                        indeterminate
                        size="64"
                        color="primary"
                    ></v-progress-circular>
                </v-overlay>
            </v-card>
        </v-expand-transition>

        <v-expand-transition>
            <v-card
                v-show="expandConfirmUpload"
                max-height="95vh"
            >
                <v-card-title>
                    {{ uploadConfirmText }}
                </v-card-title>
                <v-alert
                    v-if="alert.display"
                    prominent
                    type="error"
                    dense
                >
                    {{ alert.text }}
                </v-alert>
                <v-card-text>
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="students"                    
                        height="45vh"
                        fixed-header
                        :items-per-page="itemsPerPage"
                        :loading="loading"
                        :show-select="showSelect"
                    >
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                                v-if="item.error"
                                small
                                color="red"                            
                            >
                                mdi-alert-circle
                            </v-icon>
                            <v-icon
                                v-if="item.error === 0"
                                small
                                color="green"                            
                            >
                                mdi-check-all
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-card-actions
                    class="px-6"
                >
                    <v-spacer></v-spacer>
                    <!-- <v-btn
                        v-if="!deleteRecords"
                        color="primary"
                        outlined
                        small
                        class="mr-2"
                        @click="closeUploadConfirm"
                    >
                        Cancel
                    </v-btn> -->
                    <v-btn
                        v-if="deleteRecords"
                        color="primary"
                        outlined
                        small
                        class="mr-2"
                        @click="closeDeleteRecords"
                    >
                        <v-icon left>mdi-arrow-left</v-icon>
                        Back
                    </v-btn>
                    <!-- <v-btn
                        v-if="deleteRecords"
                        color="primary"
                        dark
                        small
                        class="mr-2"
                        @click="deleteSelectedRecords"
                    >
                        Delete
                    </v-btn> -->
                    <!-- <v-btn
                        v-if="!deleteRecords"
                        color="primary"
                        outlined
                        small
                        class="mr-2"
                        @click="selectRecords"
                    >
                        Delete Records
                    </v-btn> -->
                    <v-btn
                        color="primary"
                        outlined
                        small
                        class="mr-2"
                        @click="closeUploadConfirm"
                    >
                        Close Upload
                    </v-btn>
                    <v-btn
                        color="primary"
                        dark
                        small
                        @click="uploadConfirm"
                    >
                        Confirm Upload
                    </v-btn>
                </v-card-actions>

                <v-overlay
                    :value="overlay"
                    :absolute="absolute"
                    color="#fff"
                    opacity="0.9"
                >                
                    <v-card                    
                        flat
                        width="400"
                        light
                    >
                        <v-row
                            align-content="center"
                            justify="center"
                        >
                            <v-col 
                                cols="12"
                                class="subtitle-1 text-center"
                            >
                                {{ uploadingText }}
                            </v-col>
                            <!-- <v-col 
                                cols="6"
                                v-show="!uploadComplete"
                            >
                                <v-progress-linear
                                    v-model="progress"
                                    height="6"                        
                                    color="primary"
                                    indeterminate
                                    rounded
                                >                        
                                </v-progress-linear>
                            </v-col> -->
                            
                        </v-row>                    
                    </v-card>
                </v-overlay>

                <v-overlay
                    :value="overlayDeleteConfirm"
                    :absolute="absolute"
                    color="#fff"
                    opacity="0.9"
                >
                    <v-card 
                        class="pa-2"
                        width="300"
                        light
                    >
                        <v-row
                            align-content="center"
                            justify="center"
                        >
                            <v-col 
                                cols="12"
                                class="subtitle-1 text-center"
                            >
                                {{ deleteRecordsMessage }}
                            </v-col>
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                outlined
                                class="mr-4"
                                color="primary"
                                small
                                @click="cancelDeleteRecords"
                            >
                                Cancel
                            </v-btn>
                            <v-btn                            
                                color="primary"
                                dark
                                small
                                @click="deleteSelectedRecordsConfirm"                            
                            >
                                Delete
                            </v-btn>
                        </v-card-actions>
                    </v-card>        
                </v-overlay>

                <v-snackbar
                    v-model="snackbar.display"
                    :color="snackbar.color"
                >
                    {{ snackbar.text }}
                </v-snackbar>
            </v-card>
        </v-expand-transition>    
     </v-dialog>        
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import UploadService from "../services/UploadFileService";
export default {
    computed: {
      //
    },

    data: () => ({
        dialog: false,
        file: null,
        progress: 0,        
        message: '',
        messageColor: '',
        expandFileSelect: false,
        expandConfirmUpload: false,
        students: [],        
        itemsPerPage: -1,
        loading: false,
        absolute: true,
        overlay: false,
        overlayDeleteConfirm: false,
        uploadingText: null,
        uploadingMessages: [
            'Please wait...',
            'Working on your request...',
            'Taking a bit long...',
            'Still working...'
        ],
        uploadConfirmText: '',
        showSelect: false,
        selected: [],
        deleteRecords: false,
        deleteRecordsMessage: '',        
        overlayDownload: false,
        snackbar: {
            display: false,
            text: null,
            color: 'primary'
        },
        alert: {
            display: false,
            text: null,
        },
        headers: [
            {text: 'Student ID', value: 'id', width: 90, sortable: false},
            {text: 'Last Name', value: 'last_name', sortable: false},
            {text: 'First Name', value: 'first_name', sortable: false},
            {text: 'SEA Reg No.', value: 'sea_no', sortable: false},
            {text: 'Class', value: 'class_id', width: 100, sortable: false},
            {text: 'DOB', value: 'date_of_birth', width: 120, sortable: false},               
            {text: 'House', value: 'house_name', sortable: false},                
            {text: 'Entry Date', value: 'entry_date', sortable: false, width: 120},  
            {text: '', value: 'actions', sortable: false},
        ],
        headersDefault: [
            {text: 'Student ID', value: 'id', width: 90, sortable: false},
            {text: 'Last Name', value: 'last_name', sortable: false},
            {text: 'First Name', value: 'first_name', sortable: false},
            {text: 'SEA Reg No.', value: 'sea_no', sortable: false},
            {text: 'Class', value: 'class_id', width: 100, sortable: false},
            {text: 'DOB', value: 'date_of_birth', width: 120, sortable: false},               
            {text: 'House', value: 'house_name', sortable: false},                
            {text: 'Entry Date', value: 'entry_date', sortable: false, width: 120},  
            {text: '', value: 'actions', sortable: false},
        ],
        headersAll: [
            {text: 'Student ID', value: 'id', width: 90, sortable: false},
            {text: 'Last Name', value: 'last_name', sortable: false},
            {text: 'First Name', value: 'first_name', sortable: false},
            {text: 'SEA Reg No.', value: 'sea_no', sortable: false},
            {text: 'Class', value: 'class_id', width: 100, sortable: false},
            {text: 'DOB', value: 'date_of_birth', width: 120, sortable: false},               
            {text: 'House', value: 'house_name', sortable: false},                
            {text: 'Entry Date', value: 'entry_date', sortable: false, width: 120}, 
            {text: 'Other Names', value: 'middle_name', sortable: false},
            {text: 'Gender', value: 'sex', sortable: false},
            {text: 'Address', value: 'home_address', sortable: false},
            {text: 'Town', value: 'address_line_2', sortable: false},
            {text: 'Regional Corporation', value: 'regional_corporation', sortable: false},
            {text: 'Student Phone (Mobile)', value: 'phone_home', sortable: false},
            {text: 'Student Email', value: 'email', sortable: false},
            {text: 'Blood Group', value: 'blood_type', sortable: false},
            {text: 'Previous School', value: 'previous_school', sortable: false},
            {text: 'SEA Number', value: 'sea_no', sortable: false},
            {text: 'Religion', value: 'religion', sortable: false},
            {text: 'Ethnic Group', value: 'ethnic_group', sortable: false},
            {text: 'Country of Birth', value: 'place_of_birth', sortable: false},
            {text: 'Nationality', value: 'nationality', sortable: false},
            {text: 'Living Status', value: 'living_status', sortable: false},
            {text: "Mother's Name", value: 'mother_name', sortable: false},
            {text: "Mother's Marital Status", value: 'mother_marital_status', sortable: false},
            {text: "Mother's Address", value: 'mother_home_address', sortable: false},
            {text: "Mother's Occupation", value: 'mother_occupation', sortable: false},
            {text: 'Mother Employer/Company', value: 'mother_business_place', sortable: false},
            {text: "Mother Work Address", value: 'mother_business_address', sortable: false},
            {text: 'Mother Phone (Home)', value: 'mother_phone_home', sortable: false},
            {text: 'Mother Phone (Work)', value: 'mother_business_phone', sortable: false},
            {text: 'Mother Phone (Mobile)', value: 'mobile_phone_mother', sortable: false},
            {text: 'Mother Email Address', value: 'email_mother', sortable: false},
            {text: 'Mother ID Card', value: 'id_card_mother', sortable: false},
            {text: "Father's Name", value: 'father_name', sortable: false},
            {text: "Father's Marital Status", value: 'father_marital_status', sortable: false},
            {text: "Father's Address", value: 'father_home_address', sortable: false},
            {text: "Father's Occupation", value: 'father_occupation', sortable: false},
            {text: "Father's Employer/Company", value: 'father_business_place', sortable: false},
            {text: "Father's Work Address", value: 'father_business_address', sortable: false},
            {text: "Father's Phone(Home)", value: 'father_phone_home', sortable: false},
            {text: "Father's Phone (Work)", value: 'father_business_phone', sortable: false},
            {text: "Father's Phone(Mobile)", value: 'mobile_phone_father', sortable: false},
            {text: "Father's Email Address", value: 'email_father', sortable: false},
            {text: "Father's ID Card", value: 'id_card_father', sortable: false},
            {text: "Guardian's Name", value: 'guardian_name', sortable: false},
            {text: "Guardian's Marital Status", value: 'guardian_marital_status', sortable: false},
            {text: "Guardian's Address", value: 'home_address_guardian', sortable: false},
            {text: "Guardian's Occupation", value: 'guardian_occupation', sortable: false},
            {text: "Guardian's Employer/Company", value: 'guardian_business_place', sortable: false},
            {text: "Guardian's Work Address", value: 'guardian_business_address', sortable: false},
            {text: "Guardian's Phone(Home)", value: 'home_phone_guardian', sortable: false},
            {text: "Guardians' Phone(Work)", value: 'business_phone_guardian', sortable: false},
            {text: "Guardian's Phone(Mobile)", value: 'mobile_phone_guardian', sortable: false},
            {text: "Guardian's Email Address", value: 'email_guardian', sortable: false},
            {text: "Guardian's ID Card", value: 'id_card_guardian', sortable: false},
            {text: 'Number of Children in Family', value: 'no_in_family', sortable: false},
            {text: 'Number of Children at Home', value: 'no_at_home', sortable: false},
            {text: 'Place in Family', value: 'place_in_family', sortable: false},
            {text: 'Emergency Contact / Address', value: 'emergency_contact', sortable: false},
            {text: 'Emergency Phone (Home)', value: 'emergency_home_phone', sortable: false},
            {text: 'Emergency Phone (Work)', value: 'relative_in_school', sortable: false},
            {text: 'Emergency Contact Relation to Child', value: 'relation_to_child', sortable: false},
            {text: 'Health Conditions', value: 'medical_history', sortable: false},
            {text: 'Serious Illness', value: 'other_illness', sortable: false},
            {text: 'Allergies', value: 'allergy', sortable: false},
            {text: 'Hepatits', value: 'hepatitis', sortable: false},
            {text: 'Polio', value: 'polio', sortable: false},
            {text: 'Diphtheria', value: 'diphtheria', sortable: false},
            {text: 'Tetanus', value: 'tetanus', sortable: false},
            {text: 'Yellow Fever', value: 'yellow_fever', sortable: false},
            {text: 'Measles', value: 'measles', sortable: false},
            {text: 'T.B.', value: 'tb', sortable: false},
            {text: 'Chicken Pox', value: 'chicken_pox', sortable: false},
            {text: 'Typhoid', value: 'typhoid', sortable: false},
            {text: 'Rheumatic Fever', value: 'rheumatic_fever', sortable: false},
            {text: 'Poor Eyesight', value: 'poor_eyesight', sortable: false},
            {text: 'Poor Hearing', value: 'poor_hearing', sortable: false},
            {text: 'Diabetes', value: 'diabetes', sortable: false},
            {text: 'Asthma', value: 'asthma', sortable: false},
            {text: 'Epilepsy', value: 'epilepsy', sortable: false},
            {text: 'Special Considerations', value: 'special_consideration', sortable: false},
            {text: 'Extra-Curricular Interests', value: 'achievements', sortable: false},
            {text: 'Device Type', value: 'device_type', sortable: false},
            {text: 'School Feeding', value: 'school_feeding', sortable: false},
            {text: 'School Transport', value: 'transport', sortable: false},
            {text: 'Internet Access', value: 'internet_access', sortable: false},
            {text: '', value: 'actions', sortable: false},
        ]
    }),

    watch: {
        file: {
            handler (val) {
                if(val) this.uploadFile();
            }
        }
    },

    methods: {
        ...mapActions({
            getDownloadTemplate: 'admin/dowloadRegistrationTemplate',
            uploadStudents: 'admin/uploadStudents',
        }),

        ...mapMutations({
            setNewStudents: 'admin/setNewStudents',
        }),

        initialize () {
            this.expandFileSelect = true;
        },        

        downloadTemplate () {
            this.overlayDownload = true;            
            this.getDownloadTemplate()
               .then(response => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const now = new Date().getTime();
                    link.setAttribute('download', `Registration Upload-${now}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    this.overlayDownload = false;            //         
               })
               .catch( error => {
                   if(error.response) console.log(error.response);
                   else console.log(error);
                   this.overlayDownload = false;
                   
               })

        },        

        selectFile (file) {
            this.progress = 0;
            this.file = file;
            this.message = null;
        },

        async uploadFile () {
            if(!this.file) {
                this.messageColor = "red"
                this.message = "Please select a file!";
                return;
            }

            this.message = "";
            this.overlayDownload = true;
            this.loading = true;

            try {
                const { data } = await UploadService.upload(this.file, (event) => {
                    this.progress = Math.round((100 * event.loaded) / event.total);
                })
                
                if(data.length > 0 && Object.keys(data[0]).length > 8){
                    this.headers = this.headersAll;
                }
                this.students = data;

                setTimeout(() => {
                    this.expandFileSelect = false;
                    this.loading = false;
                }, 700)

                setTimeout(() => {
                    this.expandConfirmUpload = true;
                    this.uploadConfirmText = "Confirm Upload Students"
                }, 700);
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error)
                this.progress = 0;
                this.message = "Could not upload the file.";
                this.messageColor = 'red'
                this.file = null;
            } finally {
                this.overlayDownload = false;
            }

        },
       

        deleteSelectedRecords () {
            this.deleteRecordsMessage = `Delete ${this.selected.length} record ?`;
            if(this.selected.length > 1)
            this.deleteRecordsMessage = `Delete ${this.selected.length} records ?`;
            this.overlayDeleteConfirm = true;           
           
        },

        cancelDeleteRecords () {
            this.overlayDeleteConfirm = false;
            this.deleteRecordsMessage = '';
        },

        deleteSelectedRecordsConfirm () {
            this.cancelDeleteRecords();
            this.selected.forEach(value => {                
                this.students.splice(this.students.indexOf(value), 1);
            })
            this.selected = [];
        },

        selectRecords () {
            this.showSelect = true;
            this.deleteRecords = true;
            this.uploadConfirmText = "Select Records To Delete"
        },

        closeDeleteRecords () {
            this.deleteRecords = false;
            this.showSelect = false;
            this.uploadConfirmText = "Confirm Upload Students"
        },

        async uploadConfirm () {
            this.overlay = true;
            this.uploadingText = "Uploading Students."
            // this.progress = 10;
            let messageCount = this.uploadingMessages.length;
            let index = 0;
            let messageInterval = setInterval(() => {
                if(index < (messageCount - 1)) index++;
                else index = 0;
                this.uploadingText = this.uploadingMessages[index];
                // console.log(`index: ${index}, text: ${this.uploadingMessages[index]}`)
            }, 3000);
            this.setNewStudents(this.students); 
            try {
                const { data } = await this.uploadStudents();
                console.log(data)
                if(this.uploadErrorCheck(data)) {
                    this.alert.text = "Some records could not be uploaded";
                    this.alert.display = true;
                }
                this.uploadConfirmText = "Upload Complete"
                this.students = data;
                clearInterval(messageInterval);
                this.uploadingText = "Upload Complete.";
                this.$emit("update-students");
                setTimeout(() => {
                    this.overlay = false
                }, 1000)
                this.snackbar.text = "Upload Complete.";
                this.snackbar.color = "primary";
                this.snackbar.display = true;
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                this.overlay = false;
                this.alert.text = "An Error has occured, data could not be uploaded";
                this.alert.display = true;
            }   
        },

        uploadErrorCheck (data) {
            let hasError = false;
            data.forEach(record => {
                if(record.error == 1) {
                    hasError = true;
                }
            })
            return hasError;
        },

        close () {
            this.dialog = false;
            this.file = null;
            this.progress = 0;
            this.message = null;
            this.alert.display = false;
        },

        closeUploadConfirm () {
            this.dialog = false;
            this.alert.display = false;
            this.expandConfirmUpload = false;
            this.expandFileSelect = false;
            this.file = null;
            this.progress = 0;
            this.message = null;
            this.headers = this.headersDefault;
        }
    }
}
</script>